import { FETCH_OVERVIEW_REQUEST, FETCH_OVERVIEW_SUCCESS, SET_OVERVIEW_DATA, 
    IS_OVERVIEW_FILTER_APPLIED, CLEAR_OVERVIEW_FILTER, SET_OVERVIEW_FILTER_DATA } from './actionTypes';

export const auditReducer = (state, action) => {
    switch(action.type) {      
        case FETCH_OVERVIEW_REQUEST:
            return {
                ...state,
                overview: []
            };
        case FETCH_OVERVIEW_SUCCESS:
            return {
                ...state,
                overview: InitialOverviewData(action.payload.overview)
            };
        case SET_OVERVIEW_DATA:
            const isEnable = isEnableExport(action.payload.overview);
            return {
                ...state,
                overview: action.payload.overview,
                isBtnExportEnable: isEnable,
            }; 
        case CLEAR_OVERVIEW_FILTER: 
            return {
                ...state,
                isClearOverviewFilter: action.payload.isClearOverviewFilter,
                isOverviewFilterApplied: false,
                overviewFilterData: [],
                overviewColumnFilterIndexes: []
            }  
        case IS_OVERVIEW_FILTER_APPLIED:
            return {
                ...state,
                isOverviewFilterApplied: action.payload.isOverviewFilterApplied,
                overviewFilterData: action.payload.overviewFilterData,
                overviewColumnFilterIndexes: action.payload.overviewColumnFilterIndexes
            }     
        case SET_OVERVIEW_FILTER_DATA:
            return {
                ...state,
                overviewColumnFilterIndexes: action.payload.overviewColumnFilterIndexes,
                overviewFilterData: action.payload.overviewFilterData,
                isBtnExportEnable: isEnableExport(action.payload.overviewFilterData && 
                                    action.payload.overviewFilterData.length > 0 ? action.payload.overviewFilterData 
                                    : state.overview)
            }        
        default : 
            return state;   
    }
}

function InitialOverviewData(data) {
    if (data && data.length > 0) {
        data = data.map(d => {
            return {
                ...d,
                contractDetails: d.contractDetails.map(c => {
                    return {
                        ...c,
                        isChecked: false                        
                    }
                }),
                isBPPartialyChecked: false,
                isChecked: false,
            }
        });
    }

    return data;
}

function isEnableExport(data) {
    let isEnable = false;
    if (data && data.length > 0) {
        data.map(d => {
            if (d.contractDetails && d.contractDetails.length > 0) {
                if (d.contractDetails.some(item => item.isChecked)) {
                    isEnable = true;
                }
            }
        });
    }

    return isEnable;
}